import { render, staticRenderFns } from "./PosTotal.vue?vue&type=template&id=208d8780&scoped=true"
import script from "./PosTotal.vue?vue&type=script&lang=js"
export * from "./PosTotal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "208d8780",
  null
  
)

export default component.exports